// extracted by mini-css-extract-plugin
export default {"Area":"VerifyBlocked_Area__Dtc9d","Icon":"VerifyBlocked_Icon__uULvU","Camera":"VerifyBlocked_Camera__1zXrq"};